export default __webpack_public_path__ + "static/media/william.1b1a7bd7.webp";